import { Checkbox, Stack } from '@mantine/core';

import { SECTIONS } from '../constants/pageAccess';
import { usePageAccessToggles } from '../hooks/usePageAccessToggles';
import { roleTypes } from '../types';

import { PageAccessSectionCard } from './PageAccessSectionCard';

type Props = {
  value: roleTypes.PageAccessConfig;
  onChange: (value: roleTypes.PageAccessConfig) => void;
};

export const PageAccessCheckboxes = ({ value, onChange }: Props) => {
  const { getSelected, allFull, anyChecked, toggleAll, toggleSection, togglePlatform, toggle } =
    usePageAccessToggles({ value, onChange });

  return (
    <Stack gap="md">
      <Checkbox
        label="All"
        checked={allFull}
        indeterminate={!allFull && anyChecked}
        onChange={toggleAll}
      />
      {SECTIONS.map((section) => (
        <PageAccessSectionCard
          key={section.key}
          section={section}
          getSelected={getSelected}
          onToggleSection={() => toggleSection(section)}
          onTogglePlatform={(platform) => togglePlatform(section, platform)}
          onToggle={(platform, department) => toggle(section.key, platform, department)}
        />
      ))}
    </Stack>
  );
};
